import { useMutation, useQueryClient } from "@tanstack/react-query";
import { taskApi } from "../service";
import { taskKeys } from "../task.keys";
import { scheduleKeys } from "../../../schedule/api/schedule.keys";

/** `Rückgängig` behind a mistaken tap — see useRevertAppointmentPhase. */
export function useRevertTaskPhase() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }: { id: number }) => taskApi.revertPhase(id).then((r) => r.data),
    onSuccess: (_data, vars) => {
      queryClient.invalidateQueries({ queryKey: taskKeys.detail(vars.id) });
      queryClient.invalidateQueries({ queryKey: taskKeys.lists() });
      queryClient.invalidateQueries({ queryKey: taskKeys.all });
      queryClient.invalidateQueries({ queryKey: scheduleKeys.all });
    },
  });
}
